<template>
  <div>
    <b-row class="float-right mb-3">
      <span>Exibir</span>
      <select class="ml-2" v-model="rowsPerPage" @change="iniciaSelecionados">
        <option
          v-for="pageSize in pageSizeMenu"
          :value="pageSize"
          v-bind:key="pageSize"
        >
          {{ pageSize }}
        </option>
      </select>
      <span class="ml-2 mr-3">Linhas</span>
    </b-row>

    <b-row>
      <p class="mr-3">Qual tipo de débito deseja verificar as informações ?</p>
      <b-form-radio-group
        v-model="opcaoSelecionada"
        :options="opcoes"
        class="mb-3"
        value-field="item"
        text-field="name"
      ></b-form-radio-group>
    </b-row>

    <b-row class="ml-1">
      <b-alert
        class="w-100"
        show
        style="background-color: rgb(163, 207, 222)"
        dismissible
      >
        <b>ATENÇÃO</b><br />
        - Para os débitos destacados não é permitido o parcelamento. Para
        parcelar, selecione somente os débitos não destacados.<br />
        - Para cobrança com situação "ENVIADO PROTESTO", o DRAM somente pode ser
        emitido pelos Cartórios.
      </b-alert>
    </b-row>

    <b-table
      responsive
      stacked="md"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="rowsPerPage"
      :filter="opcaoSelecionada"
      :sort-by.sync="sortBy"
      :sort-desc.sync="ordenacaoDecrescente"
      :sort-direction="ordenacaoDirecao"
      show-empty
      :small="true"
      select-mode="multi"
      :bordered="false"
       @filtered="onFiltered"
      hover
      :filter-function="filtrarPorSituacao"
      :sort-compare="ordenarValores"
      :tbody-tr-class="rowClass"
      empty-filtered-text="Não existem registros que satisfazem o critério do filtro."
      primary-key="id"
      summary="Tabela de débitos"
    >
      <!-- Selecionar -->
      <template #head(selected)>
        <b-form-checkbox
          disabled
          v-b-tooltip.hover="{ variant: 'primary' }"
          title="Clique aqui para marcar/desmarcar todos"
          v-model="selectAllRows"
          @click.native="toggleSelect()"
        />
      </template>

      <template #head(ESTADO_LANCAMENTO)>
        <span
          v-b-tooltip.hover.html="{ variant: 'primary' }"
          title="
           <strong>ATIVO:</strong> Débito ativo é o saldo devedor exigível.<br/><br/>
           <strong>SUSPENSO:</strong> Débito com exigibilidade suspensa por reclamação administrativa ou judicial.<br/><br/>
           <strong>ENVIADO PROTESTO:</strong> Emissão de DRAM somente no cartório. Emitir relatório de débitos protestados.<br/>"
        >
          Situação
          <b-icon variant="primary" icon="info-circle-fill" />
        </span>
      </template>

      <template #head(DESCRICAO_LANCAMENTO)>
        <span
          v-b-tooltip.hover.html="{ variant: 'primary' }"
          title="Passe o mouse sobre cada descrição para ver mais detalhes"
        >
          Descrição Débito
          <b-icon variant="primary" icon="info-circle-fill" />
        </span>
      </template>

      <template #head(IND_INSCRITO)="item">
        <div class="a" style="width: 80px">
          <span>{{ item.label }}</span>
        </div>
      </template>

      <template #cell(actions)="row">
        <b-button
          size="sm"
          @click="info(row.item, row.index, $event.target)"
          class="mr-1"
        >
          Info modal
        </b-button>
      </template>

      <template #head(NUMERO_PARCELAMENTO)="item">
        <div class="a" style="width: 100px">
          <span>{{ item.label }}</span>
        </div>
      </template>

      <template v-slot:cell(selected)="{ item, field: { key } }">
        <div style="cursor: pointer">
          <b-checkbox
            :disabled="item.ESTADO_LANCAMENTO === 'ENVIADO PROTESTO'"
            v-model="item[key]"
            @change="checkClicked(item)"
          >
          </b-checkbox>
        </div>
      </template>

      <template #cell(CODIGO_LANCAMENTO)="{ item }">
        <div class="mr-0" data-align="right">
          {{ item.CODIGO_LANCAMENTO }}
        </div>
      </template>

      <template v-slot:cell(detalhe)="{ item }">
        <p
          v-b-tooltip.hover.right
          title="consulta detalhes do lançamento"
          v-if="
            item.CODIGO_LANCAMENTO != null &&
            (origemAcesso === 'AD' || origemAcesso === 'GovBr')
          "
        >
          <b-button
            variant="secondary"
            class="mb-2"
            size="sm"
            @click="exibeDetalhe(item)"
          >
            <b-icon icon="receipt" aria-hidden="true"></b-icon>
          </b-button>
        </p>
      </template>

      <template #cell(DESCRICAO_LANCAMENTO)="{ item }">
        <p v-b-tooltip.hover.left :title="item.DSC_TOOLTIP">
          {{ item.DESCRICAO_LANCAMENTO }}
        </p>
      </template>

      <template #cell(ESTADO_LANCAMENTO)="{ item }">
        <p v-b-tooltip.hover.left :title="item.DSC_TOOLTIP_ESTADO">
          {{ item.ESTADO_LANCAMENTO }}
        </p>
      </template>

      <template #head(IND_PRESCRITO)>
        <span
          v-b-tooltip.hover.html="{ variant: 'primary' }"
          title="Passe o mouse sobre 'sim' para ver o procedimento para solicitar quitação administrativa"
        >
          Prescrito
          <b-icon variant="primary" icon="info-circle-fill" />
        </span>
      </template>

      <template #cell(IND_PRESCRITO)="{ item }">
        <div v-if="item.IND_PRESCRITO === 'sim'">
          <a
            :href="link"
            target="_blank"
            data-toggle="tooltip"
            data-placement="bottom"
            v-b-tooltip.hover.left
            :title="tooltipPrescrito"
          >
            <strong
              ><em>{{ item.IND_PRESCRITO }}</em></strong
            ></a
          >
        </div>
        <div v-else>
          <p>
            {{ item.IND_PRESCRITO }}
          </p>
        </div>
      </template>

      <template #cell(PAGAMENTO_VISTA)="{ item }">
        {{
          formatCurrency(
            item.VALOR_SIMPLES +
              item.VALOR_CORRECAO +
              item.VALOR_MULTA +
              item.VALOR_JUROS +
              item.VALOR_HONORARIO -
              (item.VALOR_DESCONTO + item.VALOR_DESC_HONORARIO)
          )
        }}
      </template>
    </b-table>

    <b-modal
      ref="modal-EmissaoGuia"
      hide-footer
      size="lg"
      modal-class="small-modal"
      centered
    >
      <div id="B" class="card right-half border-success mb-2">
        <div class="col-3 align-self-center">
          <img
            class="img-fluid"
            alt="Logo PBH"
            :src="$baseUrl('imgs/brasao-pbh.png')"
          />
        </div>
      </div>
      <div id="B" class="card right-half border-success">
        <small>
          <div class="mt-2 text-center">
            <span class="col-12 align-self-center"
              ><b><i>DETALHE DO LANÇAMENTO</i></b></span
            >
          </div>
          <hr />
          <b-row class="ml-2 mt-2">
            <b-col sm="1" md="4">
              <p>Lançamento:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.ACODIGOLANCAMENTO }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Situação:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.ADESCSITLANCTO }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Identificador:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.AIDENTIFICADOR }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Tipo Identificador:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.ATIPOIDENTIFICADOR }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Processo:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.APROCESSOLANCTO }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Natureza da Dívida:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.NATUREZA_DIVIDA }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Data Lançamento:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.ADATALANCAMENTO }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Data Vencimento:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.ADATAVENCIMENTO }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Data Último Pagamento:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.ADATAPAGAMENTO }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Valor Lançado:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.AVALORLANCADO }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Saldo Devedor Simples:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.AVALORSIMPLES }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Valor Correção Monetária:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.AVALORCORRECAO }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Valor Juros:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.AVALORJUROS }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Valor Multa:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.AVALORMULTA }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Valor Selic:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.AVALORSELIC }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Valor Honorários:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.AVALORHONORARIO }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Valor Devido Atualizado:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.AVALORATUALIZADO }}</p>
            </b-col>
          </b-row>
          <b-row class="ml-2">
            <b-col sm="1" md="4">
              <p>Saldo Pago:</p>
            </b-col>
            <b-col sm="2" md="8">
              <p>{{ detalhe.AVALORPAGO }}</p>
            </b-col>
          </b-row>
        </small>
      </div>
      <div id="B" class="card right-half border-success mt-2">
        <small>
          <div class="mt-2 text-left">
            <span class="col-12 align-self-left"
              ><b><i>Informações Complementares</i></b></span
            >
          </div>
          <hr />
          <b-row
            v-for="det in detalhe.ADETALHELANCTO"
            :key="det"
            class="text-left"
            align-v="left"
          >
            <b-col sm="2" md="12" class="ml-4">
              {{ formatTextHtml(det) }}
            </b-col>
          </b-row>
          <div class="mb-2"></div>
        </small>
      </div>
    </b-modal>

    <b-row class="d-flex justify-content-between mx-3">
      <b-col>
        <strong>Total de registros: {{ totalFiltrado || items.length }}</strong>
        <br />
        Página {{ currentPage }} de {{ Math.ceil((totalFiltrado || items.length) / rowsPerPage) }}
      </b-col>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalFiltrado || items.length"
        :per-page="rowsPerPage"
        aria-controls="my-table"
        align="right"
      >
      </b-pagination>
    </b-row>
  </div>
</template>

<script>
import constantes from "../constants/index";

export default {
  props: {
    items: Array,
    fields: Array,
    title: String,
    permiteParcelamento: Boolean,
    refazerAgrupamento: Boolean,
    limparSelecao: Boolean,
  },
  data() {
    return {
      opcaoSelecionada: "AMBOS",
      opcoes: [
        { item: "ATIVO", name: "Ativos" },
        { item: "SUSPENSO", name: "Suspensos" },
        { item: "AMBOS", name: "Ambos" },
      ],

      totalFiltrado: 0,

      origemAcesso: "",
      userName: "",
      origemNome: "",
      detalhe: {},
      selectAllRows: false,
      rowsPerPage: 5,
      pageSizeMenu: [5, 10, 20, 50, 100, 200],
      currentPage: 1,
      ordenarPor: "",
      sortBy: "ID_CATEGORIA_PARCTO",
      ordenacaoDecrescente: false,
      ordenacaoDirecao: "asc",
      texto: [],

      link: "https://servicos.pbh.gov.br/servicos/i/5e82412ed9521a26a95515af/5dc8470253fd6b5bbd99185f/servicos+divida-ativa-prescricao-de-debitos-inscritos",
      tooltipPrescrito:
        "Para solicitar o cancelamento do débito, acessar o Portal de Serviços da PBH, clicando no " +
        ' " ' +
        "sim" +
        ' " ',
    };
  },
  mounted() {
    this.selectAllRows = false;

    if (this.limparSelecao) {
      this.clearSelected();
    }
    if (this.refazerAgrupamento) {
      this.iniciaSelecionados();
    }
    if (this.items.length == 1) {
       this.selectAll();
    }
  },
  computed: {
    rows() {
      return this.items.length;
    },
    selecionados() {
      return this.items.filter((item) => item.selected);
    },
  },
  methods: {
    onFiltered(filtrados) {
      this.totalFiltrado = filtrados.length;
      this.currentPage = 1;  // força voltar para a página 1
    },    

    filtrarPorSituacao(item, filter) {
      if (filter === "AMBOS") return true;
      return item.ESTADO_LANCAMENTO === filter;
    },

    formatTextHtml: function (value) {
      if (value != null) {
        let arquivo = value;
        const expressao = /&nbsp;|<br>|<h6>|^<\/?detalhe_lancamento>$/g;
        let linhaFormatada = arquivo.replace(expressao, " ").trim();
        linhaFormatada = linhaFormatada.replace("</h6>", " ").trim();
        return linhaFormatada;
      }
    },

    formatCurrency: function (value) {
      if (value != null) {
        console.log("val....: " + value);
      } else {
        value = "0,00";
      }
      if (value != null) {
        let formatter = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        });
        return formatter.format(value);
      } else {
        return "R$ 0,00";
      }
    },

    toggleSelect() {
      this.selectAllRows = !this.selectAllRows;
      if (this.selectAllRows === true) this.selectAll();
      else this.clearAll();
    },

    clearSelected() {
      this.selecionados.forEach((item) => {
        this.$set(item, "selected", false);
      });
    },

    iniciaSelecionados() {
      this.selectAllRows = false;
      this.clearAll();
    },

    clearAll() {
      this.selecionados.push(
        this.items.forEach((item) => {
          this.$set(item, "selected", false);
        })
      );
      this.emitirDados();
    },

    selectAll() {
      // mudar para for
      for (let i = 0, l = this.items.length; i < l; i++) {
        if (this.items[i].ESTADO_LANCAMENTO !== "ENVIADO PROTESTO") {
          this.$set(this.items[i], "selected", true);
        }
      }
      this.emitirDados();
    },

    exibeDetalhe(item) {
      this.retornaDetalheLancto(item.CODIGO_LANCAMENTO);
      this.abrirModal("modal-EmissaoGuia");
    },

    abrirModal: function (referencia) {
      this.$refs[referencia].show();
    },

    fecharModal: function (referencia) {
      this.$refs[referencia].hide();
    },

    retornaDetalheLancto: async function (codlancamento) {
      await this.$axios
        .post(this.$env.url_backend + constantes.retornaDetalheLancamento, {
          codlancamento,
        })
        .then((response) => {
          let lista = {};
          lista = response.data[0];
          let retList = {};
          retList.ACODIGOLANCAMENTO = lista.ACODIGOLANCAMENTO;
          retList.AIDENTIFICADOR = lista.AIDENTIFICADOR;
          retList.ADATALANCAMENTO = lista.ADATALANCAMENTO;
          retList.ADATAREFERENCIA = lista.ADATAREFERENCIA;
          retList.ADATAVENCIMENTO = lista.ADATAVENCIMENTO;
          retList.ADESCTRIBUTO = lista.ADESCTRIBUTO;
          retList.NATUREZA_DIVIDA = lista.NATUREZA_DIVIDA;
          retList.ADESCSITLANCTO = lista.ADESCSITLANCTO;
          retList.AVALORLANCADO = lista.AVALORLANCADO;
          retList.AVALORPAGO = lista.AVALORPAGO;
          retList.ADATAPAGAMENTO = lista.ADATAPAGAMENTO;
          retList.AVALORATUALIZADO = lista.AVALORATUALIZADO;
          retList.AVALORSIMPLES = lista.AVALORSIMPLES;
          retList.AVALORCORRECAO = lista.AVALORCORRECAO;
          retList.AVALORMULTA = lista.AVALORMULTA;
          retList.AVALORJUROS = lista.AVALORJUROS;
          retList.AVALORSELIC = lista.AVALORSELIC;
          retList.AVALORHONORARIO = lista.AVALORHONORARIO;

          retList.ADETALHELANCTO = this.removerLinhaPorTexto(
            lista.ADETALHELANCTO,
            "ID_PESSOA_PAPEL RESPONSAVEL DENUNCIA ESPONTANEA"
          );

          retList.ADETALHEPARCTO = lista.ADETALHEPARCTO;
          retList.APROCESSOLANCTO = lista.APROCESSOLANCTO;

          this.detalhe = retList;
          /////
        })
        .catch(() => {
          this.carregando = false;
          this.mostrarConfirmacaoEmissaoGuia = false;
        });
    },

    removerLinhaPorTexto(array, texto) {
      return array.filter((item) => !item.includes(texto));
    },

    checkClicked(item) {
      if (item.selected) {
        this.$set(item, "selected", true);
      } else {
        this.$set(item, "selected", false);
      }
      this.emitirDados();
    },
    //  destacar uma linha na tabela  //
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if ((item.ID_CATEGORIA_PARCTO === 9 && !item.DESCRICAO_LANCAMENTO?.includes("ISSQN FONTE - RETIDO")) || 
         (item.DESCRICAO_LANCAMENTO?.includes("ISSQN FONTE - RETIDO") && item.IND_INSCRITO == "não")) return "table-warning";
    },
    //
    ordenarValores: function (a, b, key) {
      if (key === "VALOR_HONORARIO") {
        if (a.VALOR_HONORARIO < b.VALOR_HONORARIO) {
          return -1;
        }
        return a.VALOR_HONORARIO > b.VALOR_HONORARIO ? 1 : 0;
      } else if (key === "VALOR_JUROS") {
        if (a.VALOR_JUROS < b.VALOR_JUROS) {
          return -1;
        }
        return a.VALOR_JUROS > b.VALOR_JUROS ? 1 : 0;
      } else if (key === "VALOR_MULTA") {
        if (a.VALOR_MULTA < b.VALOR_MULTA) {
          return -1;
        }
        return a.VALOR_MULTA > b.VALOR_MULTA ? 1 : 0;
      } else return null;
    },

    emitirDados() {
      const selecionados = this.selecionados;
      const title = this.title;

      const index = selecionados.findIndex(
        (val) => (val.ID_CATEGORIA_PARCTO == 9 && !val.DESCRICAO_LANCAMENTO?.includes("ISSQN FONTE - RETIDO")) || 
                (val.DESCRICAO_LANCAMENTO?.includes("ISSQN FONTE - RETIDO") && val.IND_INSCRITO == "não"));
 
      const permiteParcelamento = index < 0;

      const indexP = selecionados.findIndex(
        (val) => val.IND_PRESCRITO == "sim"
      );

      const existePrescrito = indexP >= 0;

      const data = {
        title,
        selecionados,
        permiteParcelamento,
        existePrescrito,
      };

      this.$emit("mostrarSelecionados", data);
    },
  },
  
  async beforeMount() {
    this.userName = this.$store.getters.userInfo.preferred_username;
    this.origemAcesso = this.$store.getters.userInfo.origem;
    this.origemNome = this.$store.getters.userInfo.name;
  },
};
</script> 
<style scoped>
.table-sm td {
  padding: 0rem;
}

#ckbSelected {
  cursor: pointer;
}

</style>
